var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "close_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M11.5,25.35,10.35,24.2,16.7,17.85,10.35,11.5,11.5,10.35,17.85,16.7,24.2,10.35,25.35,11.5,19,17.85,25.35,24.2,24.2,25.35,17.85,19Z",
    transform: "translate(-10.35 -10.35)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.aac9e185a3fbead479704553b4bc2ba1.svg";
export { ForwardRef as ReactComponent };